import { render, staticRenderFns } from "./FoodTagDelete.vue?vue&type=template&id=ff1d19f6&scoped=true"
import script from "./FoodTagDelete.vue?vue&type=script&lang=js"
export * from "./FoodTagDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1d19f6",
  null
  
)

export default component.exports